<template>
  <div>
    <div class="reviews-sidebar-map-data-card">
      <div class="header">
        <img src="/google.svg" alt="Map Icone" />
        <span>Reviews</span>
      </div>
      <div style="display: flex; flex-direction: column; align-items: center">
        <span class="avarage-rating-title">{{ averageRating.toFixed(1) }}</span>
        <span class="avarage-rating-total">{{ totalReviews }} avaliações</span>
        <CustomRating :value="averageRating" />
      </div>
      <div
        style="
          height: 1px;
          width: 100%;
          border: 1px solid #e6e9eb;
          border-radius: 18px;
          margin: 10px 0;
        "
      ></div>
      <div class="reviews-sidebar-map-data-card">
        <div
          v-for="(review, index) in reviewData['reviews']"
          :key="review.photo"
          class="reviews-list-container"
        >
          <div class="reviews-list-header" @click="redirectToAuthorUrl(review.author_url)">
            <img :src="getImageUrl(review.photo)" alt="Foto do usuario" />
            <span class="name">{{ review.name }}</span>
          </div>
          <div class="reviews-list-content">
            <div>
              <span class="rating">{{ review.rating }}/5</span>
              <span class="time">{{ review.relative_time_created }}</span>
            </div>
            <span class="text">
              {{ isTextExpanded(index) ? review.text : truncateText(review.text) }}
              <span
                v-if="review.text.length > 300"
                @click="toggleTextExpansion(index)"
                class="text-expand"
              >
                {{ isTextExpanded(index) ? '...Menos' : '...Mais' }}
              </span>
            </span>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import CustomRating from '../CustomRating/CustomRating.vue'
import Multiselect from 'vue-multiselect'

export default {
  props: {
    reviewData: {
      type: Object,
      required: true,
    },
  },
  components: {
    CustomRating,
    Multiselect,
  },
  data() {
    return {
      averageRating: this.reviewData.rating || 0,
      totalReviews: this.reviewData.review_count || 0,
      reviewSelect: [],
      expandedTextIndices: [],
    }
  },
  methods: {
    redirectToAuthorUrl(authorUrl) {
      window.open(authorUrl)
    },
    getImageUrl(photoUrl) {
      const placeholder = '/google.png'
      try {
        const url = new URL(photoUrl)
        return photoUrl
      } catch (_) {
        return placeholder
      }
    },
    truncateText(text) {
      return text.length > 300 ? text.substring(0, 300) + '...' : text
    },
    toggleTextExpansion(index) {
      if (this.expandedTextIndices.includes(index)) {
        this.expandedTextIndices = this.expandedTextIndices.filter((i) => i !== index)
      } else {
        this.expandedTextIndices.push(index)
      }
    },
    isTextExpanded(index) {
      return this.expandedTextIndices.includes(index)
    },
  },
}
</script>

<style lang="scss" src="./styles.scss"></style>
